import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { isFunction } from 'lodash-es'
import { Chip, DetailsCard } from '@node-space/storybook-components'

interface GetStartedRowProps {
  messageText: string
  messageButton: string
  isRecommended?: boolean
  redirectUrl: string
  Icon: JSX.Element
  tracking?: () => void
}

const GetStartedRow = ({
  messageText,
  messageButton,
  isRecommended,
  redirectUrl,
  Icon,
  tracking,
}: GetStartedRowProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleRedirect = () => {
    navigate(redirectUrl)
    if (tracking && isFunction(tracking)) {
      tracking()
    }
  }

  return (
    <DetailsCard
      hasGutterTop
      alignCenter
      button={{
        label: messageButton,
        icon: Icon,
        onClick: handleRedirect,
      }}
    >
      <div className="flex items-center col-span-full md:col-span-1">
        <p>{messageText}</p>
        {isRecommended && <Chip className="ml-2" value={`${t('recommended')}`} />}
      </div>
    </DetailsCard>
  )
}

export default GetStartedRow
